export const justificationReasons = [
  {
    id: 'bc239252-56d0-4e86-af4e-f62eb14556a1',
    description: 'Reason 1',
    isActive: true
  },
  {
    id: 'e7747282-03c3-4af4-b2c0-a87ef7b224bf',
    description: 'Reason 2',
    isActive: true
  },
  {
    id: '20984c26-e2b9-4595-ac1c-e10d2b68e7da',
    description: 'Reason 3',
    isActive: true
  }
];
